import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },

  avatarArea: {
    marginLeft: '8px'
  },

  avatar: {
    width: '36px',
    height: '36px'
  },

  name: {
    marginLeft: '16px',
    fontSize: theme.size.base,
    color: '#3C425B',
    cursor: 'inherit'
  },

  mockAvatar: {
    borderRadius: '50%',
    animation: '$skeleton-loading 0.3s linear infinite alternate'
  },

  mockName: {
    marginLeft: '16px',
    borderRadius: '10px',
    width: '50%',
    height: '17px',
    animation: '$skeleton-loading 0.3s linear infinite alternate'
  },

  '@keyframes skeleton-loading': {
    '0%': {
      backgroundColor: 'hsl(0, 0%, 90%)'
    },

    '100%': {
      backgroundColor: 'hsl(0, 0%, 93%)'
    }
  }
}))

export default useStyles
